export const INVITE_CALL_VAP = {
    mp4: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1756809437074-video.mp4",
    configJson: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1756809437074-config.json",
    mtapConfigJson: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1756809437074-mtap.json"
};
export const FREE_CARD_VAP = {
    mp4: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1756952267964-video.mp4",
    configJson: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1756952267964-config.json",
    mtapConfigJson: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1756952267964-mtap.json"
};
export const POINTER_VAP = {
    configJson: "https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1732592404623-config.json",
    mtapConfigJson: "https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1732592404623-mtap.json",
    mp4: "https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1732592404623-video.mp4"
};
export const FIREWORKS_VAP = {
    configJson: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1763441139886-config.json",
    mtapConfigJson: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1763441139886-mtap.json",
    mp4: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1763441139886-video.mp4"
};
export const POPUP_ORDER = {
    // 免单
    FREE_CARD: 0,
    // 邀请
    INVITE_CALL: 1,
    INVITE_LIGHT_UP: 1,
    TASK: 1,
    // 队伍
    JOINED_TEAM: 2,
    CREATED_TEAM: 2,
    // 通知类
    PUBLICITY: 3,
    NOTICE: 999,
    FIXED_BAR: 9999
};
export const BID_MAP = {
    COMP_MV: 'b_daodian_lowcode_yuynwrle_mv',
    /** 组队玩法 */
    TEAM_CREATE_MV: 'b_daodian_lowcode_srquw2zf_mv',
    TEAM_CREATE_MC: 'b_daodian_lowcode_srquw2zf_mc',
    TEAM_JOIN_MV: 'b_daodian_lowcode_4wdp58wi_mv',
    TEAM_JOIN_MC: 'b_daodian_lowcode_4wdp58wi_mc',
    /**城市抽签玩法 */
    WISH_CITY_MV: 'b_daodian_lowcode_qi1jub12_mv',
    // 许愿城市按钮mv
    WISH_CITY_MC: 'b_daodian_lowcode_qi1jub12_mc',
    // 许愿城市mc
    GO_TO_ORDER_MV: 'b_daodian_lowcode_95xhowb4_mv',
    // 去下单mv
    GO_TO_ORDER_MC: 'b_daodian_lowcode_95xhowb4_mc',
    // 去下单mc
    /** 分享 */
    SHARE_MC: 'b_daodian_lowcode_figsgy29_mc',
    /** 队长积分兑换 */
    POINTS_EXCHANGE_MV: 'b_daodian_lowcode_we7ccvu0_mv',
    POINTS_EXCHANGE_MC: 'b_daodian_lowcode_we7ccvu0_mc',
    // Tab 切换
    REWORDS_TAB_MC: 'b_daodian_lowcode_4b3kr9v5_mc',
    POKE_BTN_MC: 'b_daodian_lowcode_1a6e6v3q_mc',
    // 弹窗
    TASK_POPUP_MV: 'b_daodian_lowcode_unsoumpq_mv',
    TASK_BROWSE_MC: 'b_daodian_lowcode_v4rcfmbu_mc',
    TASK_ORDER_MC: 'b_daodian_lowcode_5idym8bg_mc',
    INVITE_POPUP_MV: 'b_daodian_lowcode_yriu7az6_mv',
    // 榜单按钮
    REWARD_LIST_MC: 'b_daodian_lowcode_r9ji2wa5_mc',
    RANKING_LIST_MC: 'b_daodian_lowcode_tclpq9ex_mc',
    // 小红书任务
    RED_NOTE_TASK_MV: 'b_daodian_lowcode_x13itd18_mv',
    // 小红书分享
    RED_NOTE_SHARE_MV: 'b_daodian_lowcode_anpnfmqg_mv',
    RED_NOTE_SHARE_MC: 'b_daodian_lowcode_ipwqb4zo_mc',
    // 小红书发布审核
    RED_NOTE_AUDIT_MV: 'b_daodian_lowcode_kt414zj1_mv',
    RED_NOTE_AUDIT_MC: 'b_daodian_lowcode_qifurlaw_mc'
};
